import { render } from "./BizDropdown.vue?vue&type=template&id=f34d1e04&ts=true"
import script from "./BizDropdown.vue?vue&type=script&lang=ts"
export * from "./BizDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__